import Field from '@/classes/Form/Field'
import { FieldTypes } from '@/components/Form/FieldTypes'

export default class ArrayField extends Field {
  type: FieldTypes = FieldTypes.array
  children: Field[] = []

  setChildren(children: Field[]): this {
    this.children = children

    return this
  }
}
